import { render } from "./LoadingTitle.vue?vue&type=template&id=72d0bff2"
import script from "./LoadingTitle.vue?vue&type=script&lang=js"
export * from "./LoadingTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__